"use client";
import { motionRecipe as e } from "../foundations/motion/motion-tokens.js";
import { useEffect as t, useRef as n, useState as r } from "react";
//#region src/motion/useLoadingVisibility.ts
function i(i) {
	let [a, o] = r(!1), s = n(0);
	return t(() => {
		if (i && a) return;
		let t = i ? e.loadingDelay : Math.max(0, e.loadingMinimum - (Date.now() - s.current)), n = setTimeout(() => {
			i && (s.current = Date.now()), o(i);
		}, t);
		return () => {
			clearTimeout(n);
		};
	}, [i, a]), a;
}
//#endregion
export { i as useLoadingVisibility };
